export const formDataConstants = {
    SAVE_ACTIVITY: "SAVE_ACTIVITY",
    CLEAR_ACTIVITY: "CLEAR_ACTIVITY",
    SET_ANSWER_INPUT: "SET_ANSWER_INPUT",
    SAVE_REPORT_FILE: "SAVE_REPORT_FILE",
    CLEAR_REPORT_FILE: "CLEAR_REPORT_FILE",
    SAVE_FORM_DATA: "SAVE_FORM_DATA",
    RESET_FORM_DATA: "RESET_FORM_DATA",
    SAVE_UPLOADED_FILES: "SAVE_UPLOADED_FILES",
    RESET_UPLOADED_FILES: "RESET_UPLOADED_FILES",
}
